import React from 'react';
import { Button } from 'components/ui/button';
import { Pencil, Trash2 } from 'lucide-react';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';

interface DeviceActionsCellProps {
  row: PAYMENT_CONFIG.IGetPaymentDeviceLocation;
  onEdit: (config: Partial<Record<string, string>>, deviceId: string) => void;
  onDelete: (deviceId: string, deviceName: string) => void;
}

const DeviceActionsCell = ({ row, onEdit, onDelete }: DeviceActionsCellProps) => {
  const handleEdit = () => {
    // Create immutable update object instead of mutating deviceConfig directly
    const updatedConfig: Partial<Record<string, string>> = {
      registerId: row?.deviceregisterid,
      deviceName: row?.name,
      printConfig: row?.printConfig,
      deviceAuthCode: row?.deviceauthcode,
      tpn: row?.tpn,
    };

    if (row?.posLocationId) {
      updatedConfig.posLocationId = row.posLocationId;
    }
    if (row?.locationId) {
      updatedConfig.locationId = row.locationId;
    }

    onEdit(updatedConfig, row.id);
  };

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        data-testid="edit_device"
        aria-label="Edit device"
        onClick={handleEdit}
      >
        <Pencil size={18} className="text-gray-500" aria-hidden="true" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        data-testid="delete_device"
        aria-label="Delete device"
        onClick={() => onDelete(row.id, row.name)}
      >
        <Trash2 size={18} className="text-gray-500" aria-hidden="true" />
      </Button>
    </>
  );
};

export default DeviceActionsCell;
